<template>
  <el-dialog
    width="900px"
    title="附件库查看"
    class="sp-manager__dialog"
    :visible="show"
    :close-on-click-modal="false"
    :before-close="beforeCloseImportAttach"
    :destroy-on-close="true"
    append-to-body
  >
    <el-row>
      <el-col :span="8" style="">
        <el-input
          placeholder="请输入附件名称"
          @keydown.enter="search"
          v-model="keyword"
        />
      </el-col>
      <el-col :span="4" style="">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-col>
      <el-col :span="12" style="text-align:right">
        <el-button @click="del">删除</el-button>
        <el-button @click="exportTable">导出</el-button>
      </el-col>
    </el-row>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%;margin-top:20px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="附件编号">
        <template slot-scope="scope">{{ scope.row.file_no }}</template>
      </el-table-column>
      <el-table-column label="附件名称">
        <template slot-scope="scope">{{ scope.row.file_name }}</template>
      </el-table-column>
      <el-table-column label="附件类型" width="80">
        <template slot-scope="scope">{{ scope.row.file_type }}</template>
      </el-table-column>
      <el-table-column label="附件大小" width="100">
        <template slot-scope="scope">{{
          scope.row.size | computerSize
        }}</template>
      </el-table-column>
      <el-table-column label="上传时间" width="120">
        <template slot-scope="scope">{{
          scope.row.upload_time | dateYMDFormat
        }}</template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import utils from "@/utils.js";
export default {
  name: "attachLibraryTableDialog",
  data() {
    return {
      importAttachShow: false,
      importUrl: "",
      multipleSelection: [],
      tableData: [],
      keyword: "",
      params: {
        pageBean: {
          page: 1,
          pageSize: 500
        },
        querys: []
      }
    };
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        this.reset();
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      }
    },
    subType: {
      type: [String, Number],
      default() {
        return "";
      }
    }
  },
  methods: {
    beforeCloseImportAttach() {
      this.$emit("closeD");
    },
    search() {
      if (this.keyword) {
        this.params.querys.push({
          group: "quick",
          operation: "LIKE",
          property: "F_file_name",
          relation: "AND",
          value: this.keyword
        });
      } else {
        this.params.querys = [];
      }
      this.getList(this.subType);
    },
    reset() {
      this.keyword = "";
      this.search();
    },
    // 删除
    del() {
      if (this.multipleSelection.length) {
        const ids = this.multipleSelection
          .map(e => {
            return e.id;
          })
          .join(",");
        let dashBoardUrl = "${data}/system/attachment_library/?ids=" + ids;
        this.$http.remove(dashBoardUrl).then(resp => {
          if (resp.data) {
            this.$message.success("操作成功");
            this.reset();
          }
        });
      } else {
        this.$message.error("请选择一条数据");
      }
    },
    exportTable() {
      const url = "${data}/system/attachment_library/exportAttachmentLibrary";
      const params = utils.deepClone(this.params);
      params.querys.push({
        group: "advanced",
        operation: "EQUAL",
        property: "F_sub_type",
        relation: "AND",
        value: this.subType
      });
      this.$http.post(url, params, "", "arraybuffer").then(resp => {
        if (resp.data) this.$message.info("导出成功");
      });
    },
    //获取列表
    getList(subType) {
      const listUrl = "${data}/system/attachment_library/query";
      const param = utils.deepClone(this.params);
      param.querys.push({
        group: "advanced",
        operation: "EQUAL",
        property: "F_sub_type",
        relation: "AND",
        value: subType
      });
      this.$http.post(listUrl, param).then(resp => {
        if (resp.data) {
          this.tableData = resp.data.rows;
        }
      });
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>
